exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-admin-tsx": () => import("./../../../src/pages/admin.tsx" /* webpackChunkName: "component---src-pages-admin-tsx" */),
  "component---src-templates-network-page-tsx": () => import("./../../../src/templates/network-page.tsx" /* webpackChunkName: "component---src-templates-network-page-tsx" */)
}

